import { render } from "./vhpProductSlide.vue?vue&type=template&id=78fb4e17"
import script from "./vhpProductSlide.vue?vue&type=script&lang=js"
export * from "./vhpProductSlide.vue?vue&type=script&lang=js"

import "./vhpProductSlide.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__